import mime from 'mime';
import { useEffect, useRef } from 'react';
import ReactPlayer from 'react-player';
import styled from 'styled-components';

const Container = styled.div`
  height: 100%;
  width: 100%;
  aspect-ratio: 9 / 16;
  background-color: transparent;
  position: absolute;
  opacity: ${(props) => (props.isCurrent ? '1' : '0')};

  .story-player {
    height: 100% !important;
    width: 100% !important;
    aspect-ratio: 9 / 16;
  }
`;

const Image = styled.img`
  height: 100%;
  width: auto;
  aspect-ratio: 9 / 16;
  object-fit: cover;
`;

const Item = ({ item, index, isCurrent, paused, handlePaused }) => {
  const videoRef = useRef(null);
  const isVideo = mime.getType(item.media.uri).includes('video');

  /**
   * Control video state on navigating back or next
   */
  useEffect(() => {
    if (!videoRef.current) return;
    videoRef.current.seekTo(0);

    if (isVideo && isCurrent) handlePaused(true);
  }, [isCurrent, isVideo]);

  return (
    <Container isCurrent={isCurrent}>
      {!isVideo ? (
        <Image src={item.media.uri} />
      ) : (
        <ReactPlayer
          // controls
          ref={videoRef}
          className="story-player"
          url={item.media.uri}
          onReady={() => isCurrent && handlePaused(false)}
          playing={isCurrent && !paused}
          onPause={() => isCurrent && handlePaused(true)}
        />
      )}
    </Container>
  );
};

export default Item;
